import { render, staticRenderFns } from "./UserManagerHandler.vue?vue&type=template&id=45e87a69&"
import script from "./UserManagerHandler.vue?vue&type=script&lang=js&"
export * from "./UserManagerHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports